import { FC } from 'react';
import { Navigate } from 'react-router';
import NotFoundPage from './NotFoundPage';
import { RuntimeConfig } from '@moment/srv/core/runtime-config-builder.ts';

/**
 * Wrapper component that renders the appropriate NotFound page based on domain.
 * - For moment domains (get-moment.com): redirects to /not-found route
 * - For fotoscapes.com: renders NotFoundPage (with carousel and data fetching)
 */
const NotFoundWrapper: FC = () => {
  // Check if we're on moment domain (get-moment.com or localhost for development)
  const runtimeConfig =
    typeof window !== 'undefined' ? (window.__RUNTIME_CONFIG__ as RuntimeConfig) : null;
  const originDomain =
    runtimeConfig?.originDomain ||
    (typeof window !== 'undefined' ? window.location?.hostname || '' : '');
  
  // Check if it's a moment domain (get-moment.com or localhost for development)
  const isMomentDomain =
    originDomain.includes('get-moment');

  // Redirect to moment NOT_FOUND_ROUTE for moment domains
  if (isMomentDomain) {
    return <Navigate to="/not-found" replace />;
  }

  // Render NotFoundPage for fotoscapes.com and other domains
  return <NotFoundPage />;
};

export default NotFoundWrapper;

